import React, { useContext, useState, useEffect } from "react";
import "./sidebarCSS/sidebarchat.css";
import { Avatar, Dialog, DialogContent } from "@mui/material";
// import userPFP from "./sidebarIMG/userPFP.jpg"; // Removed static default
import { GlobalVariablesContext } from "../GlobalVariables";
import axios from "axios";
import Tick from "./Tick";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import FlagIcon from '@mui/icons-material/Flag';


function Sidebarchat({
  addNewChat,
  name,
  text,
  phone,
  admin_unseen_count,
  timestamp,
  msg_status_code,
  whatsapp_bussiness_number,
  platform = 'whatsapp',
  roomData,
  profile_picture = null, // New Prop
  business_user_id = null, // [NEW] Dynamic sender ID
  human_needs_action = false,
  handover_data = null
}) {
  const { setCurrentUser, setIsMobileSidebarHidden } = useContext(GlobalVariablesContext);
  const [openImage, setOpenImage] = useState(false);

  // Helper function to determine initial image source based on platform
  const getInitialImageSrc = () => {
    if (platform === 'whatsapp') {
      // For WhatsApp: try casualfootwears first
      return `https://casualfootwears.com/profile_pictures/${phone}.jpg`;
    } else {
      // For Instagram/Facebook: phone is user_id, not phone number
      // So prioritize profile_picture, fallback to dicebear
      if (profile_picture) {
        return profile_picture;
      } else {
        return `https://api.dicebear.com/7.x/adventurer/svg?seed=${phone || name}`;
      }
    }
  };

  const [imgSrc, setImgSrc] = useState(getInitialImageSrc());
  const [imgError, setImgError] = useState(0);

  // CRITICAL: Reset image source when props change (different user selected)
  useEffect(() => {
    setImgSrc(getInitialImageSrc());
    setImgError(0);
  }, [phone, profile_picture, platform]); // Reset when user identity changes

  const nameFormatter = (name) => {
    if (name.length > 20) {
      return name.slice(0, 10) + "...";
    }
    return name;
  }

  const msgFormatter = (msg) => {
    if (msg.length > 45) {
      return msg.slice(0, 40) + "...";
    }
    return msg;
  }

  const handleView = () => {
    setCurrentUser({
      name: name,
      text: text,
      phone: phone, // This is user_id for Meta
      wb_num: whatsapp_bussiness_number,
      platform: platform,
      conversation_id: roomData?.id,
      profile_picture: profile_picture, // Add to context
      business_user_id: business_user_id, // [NEW] Pass to context
      handover_data: handover_data, // Handover context
      original_data: roomData
    });

    if (platform === 'instagram' || platform === 'facebook') {
      const convId = roomData?.id;
      if (convId) {
        axios.post(`https://jutiyapa.com/api/conversations/${convId}/mark-as-read/`)
          .then(res => {
            console.log("Marked as read:", res.data);
            // Optional: You could update local state here if not relying on polling
          })
          .catch(err => console.error("Error marking read:", err));
      }
    }

    // Mobile View Toggle: Hide sidebar when opening chat
    if (window.innerWidth < 700) {
      setIsMobileSidebarHidden(true);
    }
  };

  const NUMBER_TAGS = {
    "919468063603": "LD",
    "918278244128": "LDS",
    "919485998901": "LTS",
    "919485998902": "LT",
    "919485998903": "AMD",
    "919485998904": "AMDI",
    "919485998905": "OLS",
    "919485998906": "OL",
    "919485998907": "LS",
    "919485998908": "TLS",
    "919485998909": "TL",
    "919485998910": "SS",
    "919485904987": "LTF",
    "919485904988": "LDF",
    "919485972920": "LMI",
    "919485972921": "LMO",
    "919499240313": "FS",
    "919485987613": "MLS",
    "919466022393": "LLS",
    "918278244127": "LD",
    "918278244130": "LTS",
    "918278244131": "LT",
    "918278244132": "AMC",
  };

  const fromWhere = (num) => {
    const cleanNum = String(num || '').replace(/\D/g, '');
    const key = cleanNum.length === 10 ? '91' + cleanNum : cleanNum;
    return NUMBER_TAGS[key] || "LD";
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    setOpenImage(true);
  };

  const handleCloseImage = (e) => {
    e.stopPropagation();
    setOpenImage(false);
  }

  // Cascading image fallback handler
  const handleImageError = () => {
    if (platform === 'whatsapp') {
      // WhatsApp fallback chain: casualfootwears → profile_picture → dicebear
      if (imgError === 0 && profile_picture) {
        console.log(`[WhatsApp] Casualfootwears failed for ${phone}, trying profile_picture`);
        setImgSrc(profile_picture);
        setImgError(1);
      } else if (imgError <= 1) {
        const fallbackAvatar = `https://api.dicebear.com/7.x/adventurer/svg?seed=${phone || name}`;
        console.log(`[WhatsApp] Fallback to dicebear for ${phone}`);
        setImgSrc(fallbackAvatar);
        setImgError(2);
      }
    } else {
      // Instagram/Facebook fallback chain: profile_picture → dicebear
      if (imgError === 0) {
        const fallbackAvatar = `https://api.dicebear.com/7.x/adventurer/svg?seed=${phone || name}`;
        console.log(`[${platform}] Profile picture failed for ${phone}, using dicebear`);
        setImgSrc(fallbackAvatar);
        setImgError(1);
      }
    }
  };


  return addNewChat ? (
    <>
      <div className={`Sidebarchat ${platform}`} onClick={handleView}>
        <div className={`chatImg ${platform}-border`} onClick={handleImageClick}>
          <Avatar src={imgSrc} className="sidebar-avatar-img" imgProps={{ onError: handleImageError }} />
          <div className="platform-icon">
            {platform === 'instagram' && <InstagramIcon sx={{ fontSize: 14, color: '#fff' }} />}
            {platform === 'facebook' && <FacebookIcon sx={{ fontSize: 14, color: '#fff' }} />}
            {platform === 'whatsapp' && <WhatsAppIcon sx={{ fontSize: 14, color: '#fff' }} />}
          </div>
        </div>
        <div className="SidebarChat_info">
          <div className="chat-header">
            <h4>
              {nameFormatter(name)} ({(phone || "").slice(2)}){" "}<span>[{fromWhere(whatsapp_bussiness_number)}]</span>
              <p></p>
            </h4>

            <span className="Chat__time-date">
              {new Date(timestamp * 1000).toLocaleTimeString([], {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
              ...
              {new Date(timestamp * 1000).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
              })}
            </span>
          </div>

          <div className="chat-footer">
            <p>
              <Tick msg_status_code={msg_status_code} />
              {msgFormatter(text)}
            </p>
            {human_needs_action && (
              <span className="msgCount" style={{backgroundColor: '#ff9800', width: 'auto', borderRadius: '4px', padding: '0px 6px', display: 'flex', alignItems: 'center', marginLeft: '5px'}} title="Action Needed">
                <FlagIcon style={{fontSize: '14px', color: 'white'}} />
              </span>
            )}
            {admin_unseen_count !== 0 && (
              <span className="msgCount">{admin_unseen_count}</span>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={openImage}
        onClose={handleCloseImage}
        maxWidth="md"
        onClick={(e) => e.stopPropagation()} // Prevent triggering parent click if any
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'hidden'
          }
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
      >
        <DialogContent style={{ padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={imgSrc}
            alt={name}
            onError={handleImageError}
            style={{
              maxWidth: '80vw',
              maxHeight: '80vh',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  ) : null;
}

export default Sidebarchat;